<template>
  <div style="margin-top: 70px">
    <v-container>
        <v-btn elevation="2" outlined fab x-large color=primary v-on:click="start" aria-label="Enter the room">
          <v-icon x-large>{{mdiCards}}</v-icon>
        </v-btn>
    </v-container> 
    <v-container>
      <v-row >
        <v-col cols="12" sm="4" offset-sm="4" >
          <v-text-field @keyup.enter="start" v-model="roomNumber" outlined clearable label="Room id" placeholder="A random name will be used"></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import router from '../router'
import { mdiCards } from '@mdi/js'
import generateRandomName from '../libs/nameGenerator'

export default {
  data () {
    return {
      roomNumber: undefined,
      mdiCards
    }
  },
  components: {},
  mounted: function () {
    this.$socket.close()
    this.$store.commit('disableDrawer')
  },
  methods: {
    start: function () {
      if (this.roomNumber !== undefined && this.roomNumber !== null && this.roomNumber !== '') {
        this.joinRoom()
      } else {
        this.createRoom()
      }
    },
    createRoom: function () {
      var tableId = generateRandomName()
      router.push({name: 'table', params: { tableId: tableId }})
    },
    joinRoom: function () {
      router.push({name: 'table', params: { tableId: this.roomNumber }})
    }
  }
}
</script>